import { render, staticRenderFns } from "./mc-console.vue?vue&type=template&id=87807a8c&scoped=true&"
import script from "./mc-console.vue?vue&type=script&lang=js&"
export * from "./mc-console.vue?vue&type=script&lang=js&"
import style0 from "./mc-console.vue?vue&type=style&index=0&id=87807a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87807a8c",
  null
  
)

export default component.exports